import { useCallback, useEffect, useRef, useState } from "react";
import { errorMessages } from "services/StandardTreatment";

// State standar untuk memanggil service: { data, loading, error, reload }.
// `error` berisi pesan siap tampil dari ErrorEnvelope (lihat errorMessages).
const useServiceData = (fetcher, deps) => {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const latest = useRef(0);

  const load = useCallback(fetcher, deps);

  const reload = useCallback(() => {
    const call = ++latest.current;
    setState((prev) => ({ ...prev, loading: true, error: null }));
    return load()
      .then((data) => call === latest.current && setState({ data, loading: false, error: null }))
      .catch((err) =>
        call === latest.current &&
        setState((prev) => ({ ...prev, loading: false, error: errorMessages(err), status: err?.response?.status }))
      );
  }, [load]);

  useEffect(() => {
    reload();
    return () => {
      latest.current += 1; // abaikan response yang datang setelah unmount / deps berubah
    };
  }, [reload]);

  return { ...state, reload };
};

export default useServiceData;
